import React from 'react';
import { Paper, Box, Typography, Stack, Avatar, Button, alpha } from '@mui/material';
import { PriorityHigh } from '@mui/icons-material';
import { ICriticalStudent } from 'services/SchoolClass/types';

interface Props {
  students: ICriticalStudent[];
}

export function ClassCriticalStudents({ students }: Props) {
  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle1" fontWeight="bold" color="text.primary" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <PriorityHigh color="error" fontSize="small" /> Atenção Requerida
      </Typography>
      
      {students.length > 0 ? (
        <Box 
          sx={{ 
            flexGrow: 1,
            maxHeight: 160, 
            overflowY: 'auto',
            pr: 1, 
            
            // 🔥 Adicionado para rolagem suave e sem "tranco" na tela
            scrollBehavior: 'smooth',
            overscrollBehavior: 'contain',
            
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-track': { background: 'transparent' },
            '&::-webkit-scrollbar-thumb': { 
              backgroundColor: 'divider', 
              borderRadius: '4px' 
            },
            '&::-webkit-scrollbar-thumb:hover': { 
              backgroundColor: 'text.secondary' 
            }
          }}
        >
          <Stack spacing={2}>
            {students.map(student => (
              <Box key={student.id} sx={{ p: 1.5, borderRadius: 2, bgcolor: 'background.default', border: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', width: '100%' }}>
                  <Avatar sx={{ width: 32, height: 32, bgcolor: 'divider', color: 'text.primary', fontSize: 12, fontWeight: 'bold' }}>
                    {student.initials}
                  </Avatar>
                  <Box sx={{ overflow: 'hidden' }}>
                    <Typography variant="body2" color="text.primary" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {student.name}
                    </Typography>
                    <Typography variant="caption" color={student.type === 'error' ? 'error.main' : 'warning.main'}>
                      {student.reason}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Nenhum aluno em estado crítico nesta turma.
        </Typography>
      )}
    </Paper>
  );
}